import moment from 'moment';

export function dateFormat(v) {
  if (!v) return '-';

  // Ambil bagian tanpa Z dan treat as local time
  const dateStr = typeof v === 'string' ? v.replace('Z', '') : v;
  const localMoment = moment(dateStr);

  return localMoment.format('DD/MM/YYYY HH:mm:ss');
}

export function dateFormatDate(v) {
  if (!v) return '-';

  // Ambil bagian tanpa Z dan treat as local time
  const dateStr = typeof v === 'string' ? v.replace('Z', '') : v;
  const localMoment = moment(dateStr);

  return localMoment.format('DD/MM/YYYY');
}
